import { MediaPreviewDialog } from '@/shared/ui/media-preview-dialog'
import { PageContainer } from '@/shared/ui/page-container'
import { FormHeader } from './form-header'
import { StepContent } from './step-content'
import { StepFooter } from './step-footer'
import { StepNav } from './step-nav'
import { useTourForm } from './use-tour-form'

/** Create / edit page of a tour. Rendering only — state, steps and save flows live in `useTourForm`. */
export function TourFormPage() {
  const form = useTourForm()
  const { tenantId, isEdit, tenantName, media, actions, steps, unsavedChangesDialog } = form

  return (
    <PageContainer>
      <FormHeader
        isEdit={isEdit}
        tenantId={tenantId}
        tenantName={tenantName}
        onBack={actions.navigateToList}
      />

      <div className="grid gap-6 lg:grid-cols-[200px_minmax(0,1fr)] lg:gap-8">
        <StepNav steps={steps.steps} onSelect={steps.goToStep} />

        <div className="min-w-0">
          <StepContent form={form} step={steps.activeStep} />
          {!isEdit && (
            <StepFooter
              isFirstStep={steps.isFirstStep}
              isLastStep={steps.isLastStep}
              blockedBy={steps.activeStepError}
              isSaving={actions.isSaving}
              onBack={steps.goBack}
              onNext={steps.goNext}
              onSubmit={() => void actions.handleSubmit()}
            />
          )}
        </div>
      </div>

      <MediaPreviewDialog
        url={media.mediaPreviewUrl}
        onClose={() => media.setMediaPreviewUrl(null)}
      />
      {unsavedChangesDialog}
    </PageContainer>
  )
}
